/* eslint-disable import/prefer-default-export */
export function getGAData(article, isBlocked) {
  const gaData = {
    contentGroup1: 'ArticleShowNewPerpetualScroll',
  };
  if (article) {
    if (article.ag) {
      gaData.dimension5 = article.ag;
    }

    if (article.authors && article.authors.length > 0) {
      let author = '';
      for (let i = 0; i < article.authors.length; i += 1) {
        author += article.authors[i].name;
        if (article.authors.length > 1 && i !== article.authors.length - 1) {
          author += ' and ';
        }
      }

      gaData.dimension4 = author;
    }

    if (article.metaInfo && typeof article.metaInfo === 'object') {
      if (article.metaInfo.CCINGUsers) {
        gaData.dimension39 = true;
        gaData.dimension41 = article.metaInfo.CCINGUsers;
      }

      if (article.metaInfo.PageNo) {
        gaData.dimension40 = true;
        gaData.dimension42 = article.metaInfo.PageNo;
      }
      if (article.metaInfo.Contenttype) {
        gaData.dimension61 = article.metaInfo.Contenttype;
      }
    }
    if (article.hl) {
      gaData.dimension35 = article.hl;
    }
  }

  if (isBlocked) {
    gaData.dimension9 = 'articleshow_withblocker';
  } else {
    gaData.dimension9 = 'articleshow';
  }

  return gaData;
}
